module.exports = __webpack_public_path__ + "static/media/cintillo_membrete.cfa2f5b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cintillo_membrete.jpg
// module id = 543
// module chunks = 0